import React, { useState, useCallback, useEffect } from 'react';
import UserContextProvider from './UserContext';
import { RefreshContext } from './components/RefreshContext';
import { AnimationContext } from './components/AnimationContext';
import OnlineUsersProvider from './OnlineUsersContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoCallManager from './components/VideoCallManager';

import Accueil from "./pages/Accueil";
import Error404 from './components/Error404';
import ProfilMember from './pages/ProfilMember';
import EditProfil from './pages/EditProfil';
import Forum from './pages/Forum';
import CreateNewSubjectForum from './pages/CreateNewSubjectForum';
import SubjectPage from './components/SubjectPage';
import ActeurDetails from './pages/ActeurDetails';
import FicheFilm from './pages/FicheFilm';
import Apropos from './pages/Apropos';
import Connexion from './pages/Connexion';
import CreerCompte from './pages/CreerCompte';
import Categories from './pages/Categories';
import Recherche from './pages/Recherche';
import FilmPop from './pages/FillmsPopulaires';
import EmuleProfil from './components/EmuleProfil';
import EditSubjectForumPage from './components/EditSubjectForumPage';
import EditReply from './components/EditReply';
import Abonnement from './pages/Abonnement';
import PushNotificationsPrompt from './components/PushNotificationsPrompt';


// 💡 TEST : Claude
import ClaudeTest from './components/ClaudeTest';

function App() {
  const [persistentError, setPersistentError] = useState(null);
  const [refreshNeeded, setRefreshNeeded] = useState(false);
  const [triggerAnimation, setTriggerAnimation] = useState(false);

  const handleTriggerAnimation = () => {
    setTriggerAnimation(!triggerAnimation);
  };

  const handleGlobalError = useCallback((message) => {
    console.error("[APP] Erreur globale:", message);
    setPersistentError(message);
  }, []);

  useEffect(() => {
    const handleFirebaseError = (event) => {
      if (
        event.message &&
        (event.message.includes("Firebase") ||
          event.message.includes("firestore") ||
          event.message.includes("conversation") ||
          event.message.includes("permission"))
      ) {
        console.warn("[APP] Erreur Firebase interceptée:", event.message);
        setPersistentError(
          "Problème de connexion détecté. Vérifiez votre réseau ou actualisez la page."
        );
        event.preventDefault();
        event.stopPropagation();
      }
    };

    window.addEventListener('error', handleFirebaseError);
    return () => {
      window.removeEventListener('error', handleFirebaseError);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="app">
      {persistentError && (
        <div className="persistent-error">
          <span>{persistentError}</span>
          <button onClick={handleRefresh}>Actualiser la page</button>
        </div>
      )}

      <LanguageProvider>
        <UserContextProvider>
          <RefreshContext.Provider value={{ refreshNeeded, setRefreshNeeded }}>
            <AnimationContext.Provider value={{ triggerAnimation, handleTriggerAnimation }}>
              <OnlineUsersProvider>
                <PushNotificationsPrompt />
                <Router>
                  <Routes>
                    <Route path="/" element={<Accueil />} />
                    <Route path="/profilMemberPage/:userId" element={<ProfilMember />} />
                    <Route path="/EditProfilPage/:userId" element={<EditProfil />} />
                    <Route path="/Forum" element={<Forum />} />
                    <Route path="/create-subject" element={<CreateNewSubjectForum />} />
                    <Route path="/subject/:id" element={<SubjectPage />} />
                    <Route path="/ActeurDetails/:id" element={<ActeurDetails />} />
                    <Route path="/ficheFilm/:id" element={<FicheFilm />} />
                    <Route path="/Propos" element={<Apropos />} />
                    <Route path="/Connexion" element={<Connexion />} />
                    <Route path="/creercompte" element={<CreerCompte />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/categories/:selectedCategory" element={<Categories />} />
                    <Route path="/Recherche" element={<Recherche />} />
                    <Route path="/FilmsPopulaires" element={<FilmPop />} />
                    <Route path="/EmuleProfil/:userId" element={<EmuleProfil />} />
                    <Route path="/edit-subject/:subjectId" element={<EditSubjectForumPage />} />
                    <Route path="/edit-reply/:postId/:replyId" element={<EditReply />} />
                    <Route path="/abonnement" element={<Abonnement />} />

                    {/* ✅ ROUTE DE TEST : Claude */}
                    <Route path="/claude-test" element={<ClaudeTest />} />

                    <Route path="*" element={<Error404 />} />
                  </Routes>

                  <VideoCallManager
                    isOpen={false}
                    onClose={() => {}}
                    targetUser={null}
                    mode="incoming"
                  />
                </Router>
              </OnlineUsersProvider>
            </AnimationContext.Provider>
          </RefreshContext.Provider>
        </UserContextProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
